import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Google Drive OAuth Callback Page (for popup flow)
 *
 * This page handles the OAuth redirect in a popup window.
 * It sends the result to the parent window via postMessage and closes.
 */
export default function DriveOAuthCallbackPage() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const status = searchParams.get('status');
    const connectorId = searchParams.get('connector_id');
    const accessToken = searchParams.get('access_token');
    const spaceId = searchParams.get('space_id');
    const error = searchParams.get('error');

    if (window.opener) {
      if (status === 'success' && connectorId && spaceId) {
        // Send success message to parent
        window.opener.postMessage(
          {
            type: 'DRIVE_OAUTH_SUCCESS',
            connectorId,
            accessToken,
            spaceId,
          },
          window.location.origin
        );
      } else if (error) {
        // Send error message to parent
        window.opener.postMessage(
          {
            type: 'DRIVE_OAUTH_ERROR',
            error: decodeURIComponent(error),
          },
          window.location.origin
        );
      }

      // Close popup immediately - no setTimeout needed
      // The postMessage is synchronous, so we can close right after
      window.close();
    } else {
      // Fallback: no opener, redirect to space detail page
      if (spaceId) {
        window.location.href = `/kms/spaces/${spaceId}?${searchParams.toString()}`;
      } else {
        window.location.href = `/kms/spaces`;
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center text-sm text-gray-400">
        {/* Minimal UI - window closes immediately */}
        <p>Redirecting...</p>
      </div>
    </div>
  );
}
